'use client'

import dynamic from 'next/dynamic'
import { Spinner } from '@repo/design-system-cf/components/spinner'

function LogoCreatorFallback() {
  return (
    <div className="flex min-h-[calc(100svh-6rem)] w-full items-center justify-center">
      <Spinner />
    </div>
  )
}

export const LogoCreatorFrame = dynamic(
  () => import('./logo-creator-frame').then(module => module.LogoCreatorFrame),
  { ssr: false, loading: LogoCreatorFallback },
)

export const LogoCreatorTool = dynamic(
  () => import('./logo-creator-tool').then(module => module.LogoCreatorTool),
  { ssr: false, loading: LogoCreatorFallback },
)

export const LogoCreatorResult = dynamic(
  () => import('./logo-creator-result').then(module => module.LogoCreatorResult),
  { ssr: false, loading: LogoCreatorFallback },
)
